const btn = document.querySelector('.js-locations-service-toggle');
const panel = document.getElementById('locations-service-panel');

if (btn && panel) {
	const labelShow = btn.dataset.labelShow;
	const labelHide = btn.dataset.labelHide;
	const textEl = btn.querySelector('.block-locations-service__toggle-text');

	function togglePanel() {
		const isOpen = panel.classList.toggle('is-open');
		btn.setAttribute('aria-expanded', isOpen);
		panel.setAttribute('aria-hidden', !isOpen);

		if (isOpen) {
			panel.style.maxHeight = panel.scrollHeight + 'px';
		} else {
			panel.style.maxHeight = '0';
		}

		if (textEl) {
			textEl.textContent = isOpen ? labelHide : labelShow;
		}
	}

	btn.addEventListener('click', togglePanel);
}
